module.exports = __webpack_public_path__ + "img/54.5.COD.b10bca7c.png";